import { Injectable } from '@angular/core';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})
export class WindspeedService {

  constructor(private utilService: UtilsService) { }

  setWindSpeedData(data, adminSelected, route) {
    const finalData = {};
    let tableData = [];
    const tableDataUnsorted = [];
    for (const item of Object.keys(data)) {
      const object = [];
      let locName = '';
      for (const element of data[item]['table_data']) {
        if (element['blockLength'] == '24hr') {
          object['24hr'] = {
            val: Number(element['data']['wg']).toFixed(1),
          };
        } else {
          object[element['timeStamp']] = {
            val: Number(element['data']['wg']).toFixed(1)
          };
        }
      }
      if (adminSelected) {
        locName = this.utilService.formatNames(data[item]['name']);
        object['District'] = {
          val: locName
        };
      } else {
        locName = this.utilService.formatNames(data[item]['name']);
        object['Basin'] = {
          val: locName
        };
      }
      if (data[item]['centroid'] != undefined && data[item]['centroid'] != null) {
        object['centroid'] = data[item]['centroid'];
      }
      if (data[item]['uuid'] != undefined && data[item]['uuid'] != null) {
        object['uuid'] = data[item]['uuid'];
      }
      tableDataUnsorted.push(object);
    }
    tableData = tableDataUnsorted;
    finalData['data'] = tableData;

    const tableColumns = [];
    const cols = this.createColumns(this.setBlockArray(data, route), adminSelected, false);
    tableColumns.push(cols);
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = cols;
    return finalData;
  }

  createColumns(columns, adminSelected, isMandal) {
    const finalColumns = [];
    if (adminSelected) {
      if (isMandal) {
        finalColumns.push({
          val: 'Mandal',
          colspan: 1,
          rowspan: 1,
          sortedHeaderVal: 'Mandal'
        });
      }
      finalColumns.push({
        val: 'District',
        colspan: 1,
        rowspan: 1,
        sortedHeaderVal: 'District'
      });
    } else {
      if (isMandal) {
        finalColumns.push({
          val: 'Sub Basin',
          colspan: 1,
          rowspan: 1,
          sortedHeaderVal: 'SubBasin'
        });
      }
      finalColumns.push({
        val: 'Basin',
        colspan: 1,
        rowspan: 1,
        sortedHeaderVal: 'Basin'
      });
    }
    for (const element in columns) {
      if (!isNullOrUndefined(element)) {
        finalColumns.push({
          val: columns[element],
          colspan: 1,
          rowspan: 1,
          sortedHeaderVal: columns[element]
        });
      }
    }
    return finalColumns;
  }

  createColumnsVillage(columns, adminSelected, isVillage) {
    const finalColumns = [];
    if (adminSelected) {
      if (isVillage) {
        finalColumns.push({
          val: 'Village',
          colspan: 1,
          rowspan: 1,
          sortedHeaderVal: 'Village'
        });
      }
      finalColumns.push({
        val: 'Mandal',
        colspan: 1,
        rowspan: 1,
        sortedHeaderVal: 'Mandal'
      });
    }
    for (const element in columns) {
      if (!isNullOrUndefined(element)) {
        finalColumns.push({
          val: columns[element],
          colspan: 1,
          rowspan: 1,
          sortedHeaderVal: columns[element]
        });
      }
    }
    return finalColumns;
  }

  setBlockArray(data, route) {
    let windSpeedDataKeys;
    for (const item of Object.keys(data)) {
      windSpeedDataKeys = [];
      for (const element of data[item]['table_data']) {
        if (element['blockLength'] === '6hr') {
          windSpeedDataKeys.push(element['timeStamp']);
        } else if (element['blockLength'] === '24hr') {
          windSpeedDataKeys.push('24hr');
        } else {
          windSpeedDataKeys.push(element['timeStamp']);
        }
      }
    }
    return this.sortKeys(windSpeedDataKeys, route);
  }

  setMandalData(data, adminSelected, route) {
    const finalData = {};
    const tableDataMandal = [];
    for (const item of Object.keys(data)) {
      const object = [];
      let locName = '';
      let pName = '';
      if (adminSelected) {
        pName = this.utilService.formatNames(data[item]['pName']);
        locName = this.utilService.formatNames(data[item]['name']);
        object['Mandal'] = {
          val: locName
        };
        object['District'] = {
          val: pName
        };
      } else {
        pName = this.utilService.formatNames(data[item]['pName']);
        locName = this.utilService.formatNames(data[item]['name']);
        object['Sub Basin'] = {
          val: locName
        };
        object['Basin'] = {
          val: pName
        };
      }
      for (const element of data[item]['table_data']) {
        if (element['blockLength'] == '24hr') {
          object['24hr'] = {
            val: Number(element['data']['wg']).toFixed(1)
          };
        } else {
          object[element['timeStamp']] = { val: Number(element['data']['wg']).toFixed(1) };
        }
      }
      if (data[item]['centroid'] != undefined && data[item]['centroid'] != null) {
        object['centroid'] = data[item]['centroid'];
      }
      if (data[item]['uuid'] != undefined && data[item]['uuid'] != null) {
        object['uuid'] = data[item]['uuid'];
      }
      tableDataMandal.push(object);
    }
    finalData['data'] = tableDataMandal;

    const tableColumns = [];
    const cols = this.createColumns(this.setBlockArray(data, route), adminSelected, true);
    tableColumns.push(cols);
    // console.log(cols);
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = cols;
    return finalData;
  }

  setVillageData(data, route) {
    const finalData = {};
    const tableDataMandal = [];
    for (const item of Object.keys(data)) {
      const object = [];
      let locName = '';
      let pName = '';
      pName = this.utilService.formatNames(data[item]['pName']);
      locName = this.utilService.formatNames(data[item]['name']);
      object['Village'] = {
        val: locName
      };
      object['Mandal'] = {
        val: pName
      };
      for (const element of data[item]['table_data']) {
        if (element['blockLength'] == '24hr') {
          object['24hr'] = {
            val: Number(element['data']['wg']).toFixed(1)
          };
        } else {
          object[element['timeStamp']] = { val: Number(element['data']['wg']).toFixed(1) };
        }
      }
      if (data[item]['centroid'] != undefined && data[item]['centroid'] != null) {
        object['centroid'] = data[item]['centroid'];
      }
      if (data[item]['uuid'] != undefined && data[item]['uuid'] != null) {
        object['uuid'] = data[item]['uuid'];
      }
      tableDataMandal.push(object);
    }
    finalData['data'] = tableDataMandal;

    const tableColumns = [];
    const cols = this.createColumnsVillage(this.setBlockArray(data, route), true, true);
    tableColumns.push(cols);
    // console.log(cols);
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = cols;
    return finalData;
  }

  sortByAlpha(array: any, adminSelected): any {
    let temp: any;
    for (let i = 0; i < array.length; i++) {
      for (let j = i + 1; j < array.length; j++) {
        if (adminSelected && array[i]['Mandal'] > array[j]['Mandal']) {
          temp = array[i];
          array[i] = array[j];
          array[j] = temp;
        } else if (!adminSelected && array[i]['Sub Basin'] > array[j]['Sub Basin']) {
          temp = array[i];
          array[i] = array[j];
          array[j] = temp;
        }
      }
    }
    return array;
  }

  setChartData(data, projConstants) {
    const keys = Object.keys(data);
    const formattedChartData = [];
    for (const key of keys) {
      const obj = {};
      for (const item of Object.keys(data[key])) {
        if (item == '6hr') {
          const timeStamps = Object.keys(data[key][item]);
          for (const timestamp of timeStamps) {
            obj[timestamp] = data[key][item][timestamp];
          }
        } else if (item == '24hr') {
          const timeStamps = Object.keys(data[key][item]);
          for (const timestamp of timeStamps) {
            obj['24hr'] = data[key][item][timestamp];
          }
        } else {
          const timeStamps = Object.keys(data[key][item]);
          for (const timestamp of timeStamps) {
            obj[timestamp] = data[key][item][timestamp];
          }
        }
      }
      obj[projConstants.CHART_DATA_COLUMNS['WINDSPEED']] = key;
      formattedChartData.push(obj);
    }
    return formattedChartData;
  }

  formatDataForChart(data) {
    const chartData = {};
    for (const range of Object.keys(data)) {
      const obj = {};
      for (const item of Object.keys(data[range])) {
        if (item == '6hr') {
          const timeStamps = Object.keys(data[range][item]);
          for (const timestamp of timeStamps) {
            obj[timestamp] = data[range][item][timestamp];
          }
        } else if (item == '24hr') {
          const timeStamps = Object.keys(data[range][item]);
          for (const timestamp of timeStamps) {
            obj['24hr'] = data[range][item][timestamp];
          }
        } else {
          const timeStamps = Object.keys(data[range][item]);
          for (const timestamp of timeStamps) {
            obj[timestamp] = data[range][item][timestamp];
          }
        }
      }
      chartData[range] = obj;
    }
    return chartData;
  }

  sortKeys(data, route) {
    const returnArray = [];
    let dummyArray = [];
    for (const timestamp of data) {

      if (route.snapshot.paramMap.get('time') == '24' && timestamp == '24hr') {
        returnArray.push(timestamp);
      } else {
        dummyArray.push(timestamp);
      }
    }
    dummyArray = dummyArray.sort();
    for (const ele of dummyArray) {
      returnArray.push(ele);
    }
    return returnArray;
  }

  get24HrsTimeStamps() {
    const today = new Date();
    const refTs = today.getTime();
    // let refTs = ProjConstants.RefTs24;
    const start = new Date(refTs);
    start.setHours(5, 30, 0, 0);
    const dayStartTs = start.getTime();
    const blockIndex = Math.floor((refTs - dayStartTs) / 21600000);
    const blocks = {};
    for (let i = 0; i < 4; i++) {
      blocks[i] = {};
      blocks[i]['timeStamp'] = dayStartTs + ((i + blockIndex) * 21600000);
      blocks[i]['timeLineName'] = {};
      blocks[i]['timeLineName']['toolTip'] = this.convertTimestampToFullBlockValue(blocks[i]['timeStamp']);
      blocks[i]['timeLineName']['label'] = this.convertTimestampToBlockValue(blocks[i]['timeStamp']);
      blocks[i]['leftSideName'] = this.convertTimestampToFullBlockValue(blocks[i]['timeStamp']);
      blocks[i]['timeLinePos'] = i;
    }
    return blocks;
  }

  get10DaysTimeStamps() {
    const today = new Date();
    const refTs = today.getTime();
    // let refTs = ProjConstants.RefTs24;
    const start = new Date(refTs);
    start.setHours(5, 30, 0, 0);
    const dayStartTs = start.getTime();
    const blockIndex = Math.floor((refTs - dayStartTs) / 21600000);
    const blocks = {};
    for (let i = 0; i < 28; i++) {
      blocks[i] = {};
      blocks[i]['timeStamp'] = dayStartTs + ((i + blockIndex) * 21600000);
      if ((i + blockIndex) % 4 == 0 || (i == 0 && blockIndex < 3)) {
        blocks[i]['timeLineName'] = {};
        blocks[i]['timeLineName']['toolTip'] = this.convertTimestampToFullBlockValue(blocks[i]['timeStamp']);
        blocks[i]['timeLineName']['label'] = this.convetTimeStampToDay(blocks[i]['timeStamp']);
      } else {
        blocks[i]['timeLineName'] = {};
        blocks[i]['timeLineName']['toolTip'] = this.convertTimestampToFullBlockValue(blocks[i]['timeStamp']);
        blocks[i]['timeLineName']['label'] = '';
      }
      blocks[i]['leftSideName'] = this.getDay(blocks[i]['timeStamp']) + '-' + this.getMonth(blocks[i]['timeStamp']) + '-' + this.getYear(blocks[i]['timeStamp']) + ' ' + this.convertTimestampToFullBlockValue(blocks[i]['timeStamp']);
      blocks[i]['timeLinePos'] = i;
    }
    return blocks;
  }

  convertTimestampToBlockValue(ts) {
    ts = Number(ts);
    let hours = new Date(ts).getHours();
    const minutes = new Date(ts).getMinutes();
    let amPm = 'A.M';
    if (hours > 12) {
      hours = hours - 12;
      amPm = 'P.M';
    }
    return hours.toString() + ':' + minutes.toString() + ' ' + amPm;
  }

  convertTimestampToBlockValueSpace(ts) {
    ts = Number(ts);
    let hours = new Date(ts).getHours();
    const minutes = new Date(ts).getMinutes();
    let amPm = 'A.M';
    if (hours > 12) {
      hours = hours - 12;
      amPm = 'P.M';
    }
    return hours.toString() + ':' + minutes.toString() + '' + amPm;
  }

  convetTimeStampToDay(ts) {
    const date = new Date(ts).toLocaleDateString();
    return date;
  }

  convertTimestampToFullBlockValue(ts) {
    ts = Number(ts);
    let starthours = new Date(ts).getHours();
    const startminutes = new Date(ts).getMinutes();
    let startamPm = 'A.M';
    if (starthours > 12) {
      starthours = starthours - 12;
      startamPm = 'P.M';
    }
    let endhours = new Date(ts + ProjConstants.MILLIS_IN_6HOURS).getHours();
    const endminutes = new Date(ts + ProjConstants.MILLIS_IN_6HOURS).getMinutes();
    let endamPm = 'A.M';
    if (endhours > 12) {
      endhours = endhours - 12;
      endamPm = 'P.M';
    }
    return starthours.toString() + ':' + startminutes.toString() + ' ' + startamPm + ' - ' + endhours.toString() + ':' + endminutes.toString() + ' ' + endamPm;
  }

  getDay(ts) {
    ts = Number(ts);
    const day = new Date(ts).getDate();
    /* if(day == 1){
      return day.toString() + "st";
    }
    else if(day == 2){
      return day.toString() + "nd";
    }
    else if(day == 3){
      return day.toString() + "rd";
    }
    else {
      return day.toString() + "th";
    } */
    return (day < 10 ? '0' : '') + day.toString();
  }

  getMonth(ts) {
    ts = Number(ts);
    // return new Date(ts).toLocaleString('default', { month: 'short' })
    const month = new Date(ts).getMonth();
    return (month + 1 < 10 ? '0' : '') + (month + 1).toString();
  }

  getYear(ts) {
    ts = Number(ts);
    return new Date(ts).getFullYear().toString().substr(-2);
  }
}
